import { render, staticRenderFns } from "./CotizacionVenta.vue?vue&type=template&id=667f1c64&"
import script from "./CotizacionVenta.vue?vue&type=script&lang=js&"
export * from "./CotizacionVenta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports